import { useState } from 'react';
import { Button } from '@/components/ui/button.tsx';
import AuthDialog from './AuthDialog';
import { useLoggedInAccounts } from '@/hooks/useLoggedInAccounts';
import { AccountSwitcher } from './AccountSwitcher';
import { cn } from '@/lib/utils';

export interface LoginAreaProps {
  className?: string;
}

export function LoginArea({ className }: LoginAreaProps) {
  const { currentUser } = useLoggedInAccounts();
  const [authDialogOpen, setAuthDialogOpen] = useState(false);
  const [isJoining, setIsJoining] = useState(false);

  const handleJoin = () => {
    if (isJoining) return;
    setIsJoining(true);
    // Always open the Welcome screen — never auto-trigger the extension.
    setAuthDialogOpen(true);
    // Brief cooldown so rapid taps can't stack dialogs.
    setTimeout(() => setIsJoining(false), 400);
  };

  return (
    <div className={cn('inline-flex items-center justify-center', className)}>
      {currentUser ? (
        <AccountSwitcher onAddAccountClick={() => setAuthDialogOpen(true)} />
      ) : (
        <Button
          type="button"
          onClick={handleJoin}
          disabled={isJoining}
          aria-busy={isJoining}
          className="flex items-center gap-2 px-5 py-2 rounded-full bg-primary text-primary-foreground font-medium transition-all hover:bg-primary/90 disabled:opacity-70"
        >
          <span className="truncate">{isJoining ? 'Opening…' : 'Join'}</span>
        </Button>
      )}

      <AuthDialog
        isOpen={authDialogOpen}
        onClose={() => setAuthDialogOpen(false)}
      />
    </div>
  );
}
